var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8_739)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7068 22.4173C20.6565 22.4173 25.4797 17.399 25.4797 11.2087C25.4797 9.92126 25.2711 8.68457 24.8872 7.53319L22.3355 9.74215C22.4195 10.2177 22.4633 10.7078 22.4633 11.2087C22.4633 15.6657 18.9906 19.2789 14.7068 19.2789C11.9786 19.2789 9.57942 17.8135 8.19671 15.5979L5.86609 17.6155C7.81297 20.5183 11.0467 22.4173 14.7068 22.4173ZM4.32352 14.2067L6.97898 11.9078C6.95998 11.6774 6.95024 11.4442 6.95024 11.2087C6.95024 6.75159 10.423 3.13842 14.7068 3.13842C17.2081 3.13842 19.433 4.37032 20.8513 6.28282L23.1713 4.27439C21.1985 1.67118 18.1403 0 14.7068 0C8.75703 0 3.93384 5.01828 3.93384 11.2087C3.93384 12.2471 4.06955 13.2525 4.32352 14.2067Z",
    fill: "url(#paint0_linear_8_739)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75373 11.0936C9.91395 11.716 10.3151 12.2043 10.8248 12.479L5.0526 17.4761C5.03952 17.369 5.01933 17.2615 4.99171 17.1543C4.79963 16.4084 4.29052 15.839 3.65564 15.5609L9.68857 10.3381C9.66847 10.5853 9.68844 10.8403 9.75373 11.0936ZM13.0375 13.4883L12.3581 12.6469C13.2011 12.4061 13.7855 11.6666 13.8955 10.817L14.6655 11.7706C14.5928 11.7817 14.5199 11.7974 14.4472 11.8177C13.6734 12.0334 13.1368 12.7105 13.0375 13.4883Z",
    fill: "url(#paint1_linear_8_739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.547679 18.3822C0.85016 19.5567 2.0105 20.2537 3.13938 19.939C4.26826 19.6243 4.93818 18.417 4.6357 17.2425C4.33322 16.068 3.17288 15.3709 2.044 15.6857C0.915123 16.0004 0.245197 17.2076 0.547679 18.3822Z",
    fill: "url(#paint2_linear_8_739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 10.9879C10.3793 11.9445 11.3243 12.5122 12.2438 12.2559C13.1632 11.9996 13.7088 11.0163 13.4624 10.0597C13.2161 9.10314 12.271 8.53545 11.3516 8.79177C10.4322 9.04809 9.8866 10.0313 10.133 10.9879Z",
    fill: "url(#paint3_linear_8_739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1338 5.00476C24.4088 6.07252 25.4637 6.70617 26.4899 6.42007C27.5162 6.13396 28.1252 5.03644 27.8502 3.96868C27.5752 2.90093 26.5204 2.26727 25.4941 2.55338C24.4679 2.83948 23.8588 3.937 24.1338 5.00476Z",
    fill: "url(#paint4_linear_8_739)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6215 5.26993C23.8049 5.98227 24.3355 6.5014 24.9731 6.68313L16.8686 13.6994C16.8646 13.545 16.8433 13.3887 16.8032 13.233C16.6182 12.5147 16.0803 11.9929 15.4355 11.8154L23.5558 4.78555C23.5585 4.94575 23.5798 5.10818 23.6215 5.26993Z",
    fill: "url(#paint5_linear_8_739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4468 14.1688C13.6685 15.0298 14.5191 15.5407 15.3466 15.31C16.1741 15.0793 16.6652 14.1943 16.4435 13.3334C16.2217 12.4724 15.3712 11.9614 14.5437 12.1921C13.7161 12.4228 13.2251 13.3078 13.4468 14.1688Z",
    fill: "url(#paint6_linear_8_739)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8_739",
    x: 0.475098,
    y: 0,
    width: 27.4412,
    height: 22.4173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0976378 0 0 0 0 0.0188976 0 0 0 0 0.181102 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8_739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_739",
    x1: 3.93384,
    y1: 19,
    x2: 27.2046,
    y2: 9.03101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_739",
    x1: 3.65564,
    y1: 16.388,
    x2: 13.2123,
    y2: 9.81787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_739",
    x1: 0.623168,
    y1: 16.0818,
    x2: 3.88445,
    y2: 19.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_739",
    x1: 10.1944,
    y1: 9.11438,
    x2: 12.8506,
    y2: 12.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_739",
    x1: 24.2024,
    y1: 2.91348,
    x2: 27.1672,
    y2: 6.42946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_739",
    x1: 15.4355,
    y1: 12.3405,
    x2: 25.368,
    y2: 7.60369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8_739",
    x1: 13.5021,
    y1: 12.4825,
    x2: 15.8928,
    y2: 15.3176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594761,
    stopColor: "#E6E3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.2c0234f6e2fa183a4817f307cdf25779.svg";
export { ForwardRef as ReactComponent };